import React from 'react';

const PracticeDetailModal = ({ 
  isOpen, 
  onClose, 
  selectedPractice,
  getMindStreamColor 
}) => {
  if (!isOpen || !selectedPractice) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: 'white',
          borderRadius: '16px',
          maxWidth: '600px',
          width: '100%',
          maxHeight: '80vh',
          overflow: 'auto',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'start'
        }}>
          <div>
            <h2 style={{ 
              margin: '0 0 8px 0', 
              color: 'var(--deep-blue)',
              fontSize: '1.5rem',
              fontWeight: '700'
            }}>
              {selectedPractice.practice_type}
            </h2>
            <div style={{ 
              display: 'inline-block',
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '0.875rem',
              fontWeight: '600',
              background: `${getMindStreamColor(selectedPractice.mindstream_type)}20`,
              color: getMindStreamColor(selectedPractice.mindstream_type)
            }}>
              {selectedPractice.mindstream_type} MindStream
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              borderRadius: '8px',
              fontSize: '1.5rem',
              color: '#64748b'
            }}
          >
            ×
          </button>
        </div>
        <div style={{ padding: '24px' }}>
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '16px',
            marginBottom: '24px'
          }}>
            <div style={{
              padding: '16px',
              background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
              borderRadius: '12px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '4px' }}>Duration</div>
              <div style={{ fontSize: '1.5rem', fontWeight: '700', color: 'var(--deep-blue)' }}>
                {selectedPractice.duration_minutes}<span style={{ fontSize: '1rem', fontWeight: '400' }}>min</span>
              </div>
            </div>
            <div style={{
              padding: '16px',
              background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
              borderRadius: '12px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '4px' }}>Quality</div>
              <div style={{ fontSize: '1.5rem', fontWeight: '700', color: 'var(--gold)' }}>
                {selectedPractice.impact_score}<span style={{ fontSize: '1rem', fontWeight: '400' }}>/10</span>
              </div>
            </div>
            <div style={{
              padding: '16px',
              background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
              borderRadius: '12px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '4px' }}>Date</div>
              <div style={{ fontSize: '0.875rem', fontWeight: '600', color: 'var(--deep-blue)' }}>
                {new Date(selectedPractice.practice_date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </div>
            </div>
          </div>
          <div>
            <h3 style={{
              margin: '0 0 12px 0',
              fontSize: '1.125rem',
              fontWeight: '600',
              color: 'var(--deep-blue)'
            }}>
              💡 Insights Gained
            </h3>
            <div style={{
              padding: '20px',
              background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.05), rgba(74, 144, 226, 0.1))',
              borderRadius: '12px',
              borderLeft: `4px solid ${getMindStreamColor(selectedPractice.mindstream_type)}`,
              minHeight: '100px',
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#334155',
              whiteSpace: 'pre-wrap'
            }}>
              {selectedPractice.notes || 'No insights recorded for this practice.'}
            </div>
          </div>
        </div>
        <div style={{
          padding: '24px',
          borderTop: '1px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              background: 'var(--deep-blue)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PracticeDetailModal;
